document.addEventListener("DOMContentLoaded", function () {

    const loadMoreButton = document.getElementById("load-more");
    if (!loadMoreButton) return;

    const paginationWrapper = document.getElementById("pagination");
    const urlBase = paginationWrapper.dataset.url;

    loadMoreButton.addEventListener("click", function () {
        let nextPage = loadMoreButton.dataset.nextPage;
        if (!nextPage) return;

        // Show loading animation
        loadMoreButton.classList.add("loading");
        loadMoreButton.querySelector(".button-text").classList.add("hidden");
        loadMoreButton.querySelector(".loading__spinner").classList.remove("hidden");

        let url = `${urlBase}?page=${nextPage}`;

        fetch(url)
            .then(response => response.text())
            .then((data) => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(data, "text/html");
                let newItems = doc.querySelector("[id^='product-grid'], [id^='article-list'], [id^='blog-posts'], [id^='list-collections'], .collection-list");
                let nextPagination = doc.querySelector("#load-more");

                if (newItems) {
                    document.querySelector("[id^='product-grid'], [id^='article-list'], [id^='blog-posts'], [id^='list-collections'], .collection-list")
                        .insertAdjacentHTML("beforeend", newItems.innerHTML);
                }

                if (nextPagination) {
                    loadMoreButton.dataset.nextPage = nextPagination.dataset.nextPage;
                } else {
                    loadMoreButton.style.display = "none";
                }
            })
            .catch(error => console.error("Error loading more content:", error))
            .finally(() => {
                // Hide loading animation
                loadMoreButton.classList.remove("loading");
                loadMoreButton.querySelector(".button-text").classList.remove("hidden");
                loadMoreButton.querySelector(".loading__spinner").classList.add("hidden");
            });
    });




    
});

if (!customElements.get('card-product-update')) {
    customElements.define('card-product-update', class CardProductUpdate extends HTMLElement {
        constructor() {
        super();
        // Listen for changes on radio buttons within this component
        this.addEventListener('change', (e) => this.onVariantChange(e));
        }

        onVariantChange(event) {
        const { target } = event;
        if (!target.classList.contains('js-variant-radio')) return;

        const { image: variantImage, priceHtml: escapedHtml, detail: sub } = target.dataset;
        const variantId = target.value;

        // 1. Reference the outermost parent to reach images and the form
        const cardWrapper = this.closest('.product-card-wrapper');
        if (!cardWrapper) return;

        // 2. Decode and Render Price
        const cleanHtml = this.decodeHtml(escapedHtml);
        
        // Update the price inside the component (the info section)
        //const internalPrice = this.querySelector('.js-card-price');
        //if (internalPrice) this.updateElementContent(internalPrice, cleanHtml);
        
        // Update the price inside the "Add to Cart" button (outside the component)
        const buttonPrice = cardWrapper.querySelector('.quick-add__submit .price-wrapper');
        if (buttonPrice) this.updateElementContent(buttonPrice, escapedHtml);

        // Show the "Add" label/icon (removes the hidden class once a variant is chosen)
        const horQuickAdd = cardWrapper.querySelector('.Hor-quick-add');
        if (horQuickAdd) horQuickAdd.classList.remove("hidden");

        //update the labelling and enable the button
        const productSubtitle= cardWrapper.querySelector('.product-subtitle');
        if (productSubtitle) productSubtitle.innerText= sub;
    
        const buttonSubmit = cardWrapper.querySelector('.quick-add__submit');
        if (buttonSubmit) {
            buttonSubmit.disabled = false;
            buttonSubmit.classList.add("justify")
        }

        // 4. Update Product Image (Targeting the image in the card__media section)
        const mainImage = cardWrapper.querySelector('.card__media img');
        if (mainImage && variantImage) {
            mainImage.setAttribute('src', variantImage);
            mainImage.setAttribute('srcset', variantImage);
        }

        // 5. Update Form State (Hidden Input ID)
        const hiddenInput = cardWrapper.querySelector('input[name="id"]');
        if (hiddenInput) {
            hiddenInput.value = variantId;
            hiddenInput.removeAttribute('disabled'); // Ensure input is active
        }

        // 6. Update all links (Title and Image) to include the variant ID
        this.updateLinks(cardWrapper, variantId);
        }

        /**
         * Decodes escaped HTML strings safely
         */
        decodeHtml(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.documentElement.textContent;
        }

        /**
         * Injects HTML and cleans up "From" or "À partir de" text
         */
        updateElementContent(element, html) {
        if (!element) return;
        element.innerHTML = html;
        
        const priceItems = element.querySelectorAll('.price-item');
        priceItems.forEach(item => {
            item.textContent = item.textContent.replace(/À partir de|From/g, '').trim();
        });
        }

        /**
         * Updates all anchor tags to point to the specific variant
         */
        updateLinks(container, id) {
        container.querySelectorAll('a').forEach(link => {
            if (!link.href || link.href.includes('javascript:')) return;
            try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('variant', id);
            link.href = url.toString();
            } catch (e) {
            // Ignore invalid or relative URLs that don't match the origin
            }
        });
        }
    });
}
